import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useQuizQuestionClone({ courseID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function cloneItem(data) {
    return privateFetch
      .post(`/v1/admin/course/${courseID}/questions/copy`, data)
      .then((res) => res.data);
  }

  return useMutation(cloneItem, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('quiz-questions');
    },
  });
}

export default useQuizQuestionClone;
